import React, { Component } from 'react';
import { Button, message, Popconfirm, Table } from 'antd';
import { Link } from 'react-router';

import { queryCustomBillInfo, queryCustomBillList, queryDeleteCustomBill } from '@api/crm/custom';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      total: 0,
      pageSize: 15,
      nowPage: 1,
    };
  }

  componentWillMount() {}

  componentDidMount() {
    const { uuid } = this.props.params;
    this.getCustomBillList(uuid, 1, 15);
    this.getCustomBillInfo('c5213f9a5a1611e7ad2600163e0025a0');
  }

  getCustomBillList = (uuid, pageNo, pageSize) => {
    const params = {};
    params.customerUuid = uuid;
    params.pageNo = pageNo || 1;
    params.pageSize = pageSize || 15;
    queryCustomBillList(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          data: res.data.result,
          total: res.data.totalCount,
          pageSize: res.data.pageSize,
          nowPage: res.data.pageNo,
        });
      }
    });
  };

  getCustomBillInfo = uuid => {
    queryCustomBillInfo(uuid).then(() => {});
  };

  deleteCustomBill = uuid => {
    const context = this;
    const { nowPage, pageSize } = this.state;
    queryDeleteCustomBill(uuid).then(res => {
      if (res.statusCode === 200) {
        message.success('删除成功');
        context.getCustomBillList(nowPage, pageSize);
      } else {
        message.error(res.message);
      }
    });
  };

  columns = () => {
    return [
      {
        title: '账户名称',
        dataIndex: 'accountName',
        key: 'accountName',
        render: (text, record) => (
          <Link to={`/custom/base/edit/${record.uuid}`}>{record.bill.accountName}</Link>
        ),
      },
      {
        title: '操作',
        key: 'done',
        render: (rext, record) => (
          <span>
            <Popconfirm
              onConfirm={() => this.deleteCustomBill(record.uuid)}
              title="确定删除当前组织吗？"
              placement="topRight"
              overlayStyle={{ width: 200 }}
            >
              <a className="ant-dropdown-link">删除</a>
            </Popconfirm>
          </span>
        ),
      },
    ];
  };

  render() {
    const { data } = this.state;
    const { pageSize, total } = this.state;
    const { uuid } = this.props.params;
    const pagination = {
      total,
      showSizeChanger: true,
      pageSize,
      onShowSizeChange: (current, size) => {
        this.getCustomBillList(current, size);
      },
      onChange: current => {
        this.getCustomBillList(current, pageSize);
      },
    };

    return (
      <div>
        <Link to={`/custom/base/${uuid}/bill/add`}>
          <Button type="primary" icon="plus" style={{ marginBottom: 15 }}>
            添加
          </Button>
        </Link>
        <Table
          rowKey="uuid"
          style={{ background: '#fff' }}
          rowSelection={{}}
          columns={this.columns()}
          dataSource={data}
          pagination={pagination}
        />
      </div>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/custom/base/bill/Index.js